import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FrequencyService {
  url = '@cec-api/frequency';

  constructor(private http: HttpClient) {}

  add(form: any): Promise<any> {
    return this.http.post(this.url, form).toPromise();
  }
  get(query: any): Promise<any> {
    const params = new HttpParams({ fromObject: query });
    return this.http.get(this.url, { params }).toPromise();
  }

  getById(id: number): Promise<any> {
    return this.http.get(this.url + '/' + id).toPromise();
  }

  getFrequenciesByGroupId(id: number): Promise<any> {
    return this.http.get('@cec-api/groups/' + id + '/frequencies').toPromise();
  }

  getPendingFrequencies(): Promise<any> {
    return this.http.get(this.url + 'Pending').toPromise();
  }
}
